module.exports = __webpack_public_path__ + "static/media/back-office.a8d2abcf.png";